import Colortheme from '../Theme/Colortheme'

const ArtworkLabel = (props) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    });

    return <div style={{
        borderRadius: '10px',
        padding: '20px',
        margin: '10px',
        backgroundColor: '#FFFFFF',
        maxWidth: '500px',
        textAlign: 'start',
        gap: '1.5em',
        fontSize: '.8em',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`,
        WebkitBoxShadow: `0px 4px 15px 1px ${Colortheme.shadowColor}`
    }}>
        <div style={{
            fontSize: '1.5em'
        }}><b>{props.label.title},</b> {props.label.year}</div>
        <div>
            {Object.entries(props.label.artists).map(([id, artist]) => {
                return <div key={id} ><b>{artist}</b></div>
            })}
        </div>
        <div>
            <div>{props.label.artType}</div>
            <div>{formatter.format(props.label.price)}</div>
        </div>
        <div>{props.label.description}</div>
    </div>
}

export default ArtworkLabel;